import { classNames } from '../utilities';

export const EditAppointmentIcon = ({ fill = '', className, onClick }) => {
  return (
    <svg
      className={classNames('', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      width="17"
      height="17"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.53002 16C1.10248 16 0.740593 15.8522 0.444356 15.5565C0.148119 15.2608 0 14.8995 0 14.4728V3.16491C0 2.73815 0.148119 2.37693 0.444356 2.08123C0.740593 1.78554 1.10248 1.63769 1.53002 1.63769H8.85618L7.58661 2.90493H1.53002C1.46491 2.90493 1.40521 2.93201 1.35095 2.98617C1.29669 3.04033 1.26957 3.09992 1.26957 3.16491V14.4728C1.26957 14.5378 1.29669 14.5974 1.35095 14.6515C1.40521 14.7057 1.46491 14.7328 1.53002 14.7328H12.8586C12.9237 14.7328 12.9834 14.7057 13.0377 14.6515C13.0919 14.5974 13.1191 14.5378 13.1191 14.4728V8.37363L14.3886 7.10641V14.4728C14.3886 14.8995 14.2405 15.2608 13.9443 15.5565C13.648 15.8522 13.2861 16 12.8586 16H1.53002ZM5.07835 10.9309V8.03088L12.7463 0.376927C12.8776 0.245864 13.0219 0.150276 13.1793 0.0901656C13.3366 0.030055 13.4967 0 13.6595 0C13.8255 0 13.985 0.030055 14.138 0.0901656C14.291 0.150276 14.4304 0.243153 14.5563 0.368796L15.6191 1.42648C15.7418 1.55753 15.8359 1.70212 15.9015 1.86026C15.9672 2.01839 16 2.17868 16 2.34115C16 2.50363 15.9721 2.66122 15.9162 2.81394C15.8603 2.96665 15.7667 3.10853 15.6354 3.2396L7.94303 10.9309H5.07835ZM6.34792 9.66369H7.40265L12.678 4.39801L12.1506 3.8716L11.5858 3.32896L6.34792 8.55728V9.66369Z"
        fill="#666666"
      />
    </svg>
  );
};
